import { VuexModule, Module, Action } from 'vuex-module-decorators';
import UserService from '@/services/UserService';
import { siteDistributionDTO } from '@/types/store/DTO/siteDistributionDTO';

@Module({ namespaced: true })
class SiteDistribution extends VuexModule {
  @Action({ rawError: true })
  getSiteDistribution(): Promise<siteDistributionDTO> {
    return UserService.getSiteDistribution().then(
      (response) => {
        return Promise.resolve(response.data);
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        return Promise.reject(message);
      }
    );
  }
}
export default SiteDistribution;
